import stProductsListHomeLoan from './productsListHomeLoan.component';
import stProductsListAssetFinance from './productsListAssetFinance.component';
import productsDataFactory from './productsData.factory';
import productsService from './products.service';
import ProductFee from './productFee.model';
import Product from './product.model';
import stLendersList from './lendersList.component';
import lendersDataFactory from './lendersData.factory';
import lendersService from './lenders.service';
import stLenderDocumentsList from './lenderDocumentsList.component';
import stLenderDocumentLibrary from './lenderDocumentLibrary.component';
import LenderDocument from './lenderDocument.model';
import Lender from './lender.model';

export default angular
  .module('st.Lender', ['st.Core', 'angular-cache'])
  .component('stProductsListHomeLoan', stProductsListHomeLoan)
  .component('stProductsListAssetFinance', stProductsListAssetFinance)
  .factory('productsDataFactory', productsDataFactory)
  .service('productsService', productsService)
  .factory('ProductFee', ProductFee)
  .factory('Product', Product)
  .component('stLendersList', stLendersList)
  .factory('lendersDataFactory', lendersDataFactory)
  .service('lendersService', lendersService)
  .component('stLenderDocumentsList', stLenderDocumentsList)
  .component('stLenderDocumentLibrary', stLenderDocumentLibrary)
  .factory('LenderDocument', LenderDocument)
  .factory('Lender', Lender)
  .constant('LENDER', {
    API: {
      AVAILABLE: '/api/v1/lenders/available/',
      SPECIFIC: '/api/v1/lenders/specific/',
      DOCUMENTS: '/api/v1/lenders/documents/'
    },
    DETAILS: {
      DOCUMENT_TYPES: [
        { id: 'ALL', value: 'All' },
        { id: 'ACCREDITATION', value: 'Accreditation' },
        { id: 'LOAN_APPLICATION_FORM', value: 'Loan application form' },
        { id: 'CALCULATOR', value: 'Calculator' },
        { id: 'CALCULATOR_SCHEMA', value: 'Calculator schema' },
        { id: 'DISCHARGE_AUTHORITY_FORM', value: 'Discharge authority form' },
        { id: 'LOGO', value: 'Logo' },
        { id: 'LMI_RATE_CARD_CALCULATOR', value: 'LMI rate card/calculator' },
        { id: 'OTHER', value: 'Other' },
        { id: 'POLICY_AND_PROCEDURE_MANUALS', value: 'Policy and procedure manuals' },
        { id: 'PRODUCTS', value: 'Products' },
        { id: 'SERVICEABILITY_CALCULATOR', value: 'Serviceability calculator' },
        { id: 'LENDER_UPDATE', value: 'Lender update' },
        { id: 'TARGET_MARKET_DETERMINATION', value: 'Target Market Determination' }
      ]
    },
    CACHE: {
      STORE: {
        NAME: 'lendersCache',
        TTL: 60 * 1000,
        DELETION: 'aggressive',
        RECYCLE: 30 * 1000,
        STORAGE: 'sessionStorage'
      }
    }
  })
  .constant('PRODUCT', {
    API: {
      ASSET_FINANCE_AVAILABLE: '/api/v1/products/asset-finance-available/',
      ASSET_FINANCE_NET_MONTHLY_SURPLUS: '/api/v1/products/asset-finance-net-monthly-surplus/',
      HOME_LOAN_AVAILABLE: '/api/v1/products/home-loan-available/',
      HOME_LOAN_COMPARISON_RATE: '/api/v1/products/home-loan-comparison-rate/',
      HOME_LOAN_MAXIMUM_BORROWING: '/api/v1/products/home-loan-maximum-borrowing/'
    },
    DETAILS: {
      FEE_TYPE: [
        { id: 'APPLICATION', value: 'Application fee' },
        { id: 'UPFRONT', value: 'Upfront fee' },
        { id: 'RATE_LOCK', value: 'Rate lock fee' },
        { id: 'MONTHLY', value: 'Monthly fee' },
        { id: 'YEARLY', value: 'Annual fee' },
        { id: 'VALUATION', value: 'Valuation fee' },
        { id: 'SETTLEMENT', value: 'Settlement fee' },
        { id: 'LEGAL', value: 'Legal fee' },
        { id: 'RISK', value: 'Risk fee' },
        { id: 'ORIGINATION', value: 'Origination fee' },
        { id: 'DOCUMENT', value: 'Document fee' },
        { id: 'PPSR', value: 'PPSR fee' },
        { id: 'BOF', value: 'Broker origination fee' },
        { id: 'OTHER', value: 'Other fee' }
      ]
    },
    CACHE: {
      STORE: {
        NAME: 'productsCache',
        TTL: 60 * 1000,
        DELETION: 'aggressive',
        RECYCLE: 30 * 1000,
        STORAGE: 'sessionStorage'
      }
    }
  });
